var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-6"},[_c('v-btn',{staticClass:"text-h6 font-weight-bold text-none",attrs:{"depressed":"","large":"","rounded":"","color":"primary"},on:{"click":function($event){return _vm.purchase()}}},[_vm._v("\n    Quiero empezar ahora\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }